import { AuthProviderProps, UserManager } from 'oidc-react';
import type { Config } from './env';

export function getOidcConfig(config: Config): AuthProviderProps {
  if (!config?.authorityUrl || !config?.homeUrl) {
    console.error('Received invalid or incomplete configuration from /env', config);
    throw new Error('Invalid OIDC configuration received from backend.');
  }

  //console.log('Received config:', config);

  const clientId = config.clientId || 'FigurApp';
  const scope = config.scope; // || 'FigurApp openid profile email address bks ByggforskApps';

  const props: AuthProviderProps = {
    onSignIn: (user) => {
      window.location.replace(user?.state ? user.state.toString() : window.location.pathname);
    },
    onBeforeSignIn: () => {
      return window.location.pathname + window.location.search;
    },
    authority: config.authorityUrl,
    clientId: clientId,
    redirectUri: config.homeUrl,
    scope: scope,
    silentRedirectUri: `${config.homeUrl}/silent-renew.html`,
    // Optional: Add other OIDC settings if they need to be configurable
    // postLogoutRedirectUri: config.homeUrl as string, // Often same as redirectUri
    // responseType: 'code', // Usually 'code' for PKCE flow
  };

  return {
    ...props,
    userManager: getUserManager(props),
  };
}

export const getUserManager = (props: AuthProviderProps): UserManager => {
  const {
    authority,
    clientId,
    clientSecret, // Be cautious if using clientSecret client-side
    redirectUri,
    silentRedirectUri,
    postLogoutRedirectUri,
    responseType,
    scope,
    popupWindowFeatures,
    popupRedirectUri,
    popupWindowTarget,
    extraQueryParams,
    metadata,
  } = props;

  return new UserManager({
    authority: authority ?? '',
    client_id: clientId ?? '',
    client_secret: clientSecret, // Should typically be undefined for public clients
    redirect_uri: redirectUri ?? '',
    silent_redirect_uri: silentRedirectUri ?? redirectUri,
    post_logout_redirect_uri: postLogoutRedirectUri ?? redirectUri,
    response_type: responseType ?? 'code',
    scope: scope, // ?? 'FigurApp openid profile email address bks ByggforskApps',
    popupWindowFeatures: popupWindowFeatures,
    popup_redirect_uri: popupRedirectUri,
    popupWindowTarget: popupWindowTarget,
    extraQueryParams,
    metadata: metadata,
    redirectMethod: 'replace',
    // loadUserInfo: true, // Default is usually true, uncomment to explicitly set
  });
};
